import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { Link } from 'react-router-dom';
import { Sitemap } from '../components/Sitemap';
import { GettingStartedUnit } from '../components/GettingStartedUnit';
import { BookIcon, PlayCircleIcon, PenIcon, ArrowRightIcon, MessageSquareIcon, MapIcon, GraduationCapIcon, BookOpenIcon, BarChart2Icon } from 'lucide-react';
export function Learn() {
  const {
    isArabic
  } = useLanguage();
  return <div className="w-full px-6 md:px-10 lg:px-20 py-16" data-id="element-2989">
      <Sitemap currentPage={{
      en: 'Learn',
      ar: 'تعلم'
    }} data-id="element-2990" />
      <div className="max-w-7xl mx-auto" data-id="element-2991">
        {/* Header */}
        <div className="text-center mb-12" data-id="element-2992">
          <h1 className="text-4xl md:text-5xl font-bold text-gray-900 dark:text-white mb-4" data-id="element-2993">
            {isArabic ? 'تعلم اللغة الإنجليزية' : 'Learn English'}
          </h1>
          <p className="text-xl text-gray-600 dark:text-gray-300 max-w-2xl mx-auto" data-id="element-2994">
            {isArabic ? 'ابدأ رحلة التعلم الخاص�� بك مع دروس وتمارين مخصصة' : 'Start your learning journey with personalized lessons and exercises'}
          </p>
        </div>
        {/* Learning Path Overview */}
        <div className="bg-gradient-to-br from-blue-50 to-indigo-50 dark:from-blue-900/20 dark:to-indigo-900/20 rounded-xl p-8 mb-10" data-id="element-2995">
          <div className="flex flex-col md:flex-row items-center justify-between gap-8" data-id="element-2996">
            <div data-id="element-2997">
              <div className="flex items-center gap-3 mb-4" data-id="element-2998">
                <div className="p-2 bg-blue-100 dark:bg-blue-900/30 rounded-lg" data-id="element-2999">
                  <MapIcon className="w-5 h-5 text-blue-600 dark:text-blue-400" data-id="element-3000" />
                </div>
                <h2 className="text-2xl font-semibold text-gray-900 dark:text-white" data-id="element-3001">
                  {isArabic ? 'مسار التعلم الخاص بك' : 'Your Learning Path'}
                </h2>
              </div>
              <p className="text-gray-700 dark:text-gray-300 mb-6" data-id="element-3002">
                {isArabic ? 'تابع تقدمك واستمر من حيث توقفت. نحن نبني مسارًا مخصصًا لمساعدتك على تحقيق أهدافك في تعلم اللغة الإنجليزية.' : 'Track your progress and continue where you left off. We build a personalized path to help you achieve your English learning goals.'}
              </p>
              <Link to="/learn/path" className="inline-flex items-center gap-2 px-6 py-3 bg-blue-600 text-white rounded-xl hover:bg-blue-700 transition-colors" data-id="element-3003">
                <GraduationCapIcon className="w-5 h-5" data-id="element-3004" />
                <span data-id="element-3005">{isArabic ? 'متابعة المسار' : 'Continue Path'}</span>
              </Link>
            </div>
            <div className="flex-shrink-0 w-full md:w-auto" data-id="element-3006">
              <div className="bg-white dark:bg-gray-800 rounded-lg p-4 shadow-md" data-id="element-3007">
                <div className="flex items-center justify-between mb-3" data-id="element-3008">
                  <span className="text-sm font-medium text-gray-700 dark:text-gray-300" data-id="element-3009">
                    {isArabic ? 'تقدمك' : 'Your Progress'}
                  </span>
                  <span className="text-sm text-blue-600 dark:text-blue-400" data-id="element-3010">
                    5%
                  </span>
                </div>
                <div className="h-2 bg-gray-200 dark:bg-gray-700 rounded-full overflow-hidden" data-id="element-3011">
                  <div className="h-full bg-blue-600 dark:bg-blue-500 rounded-full" style={{
                  width: '5%'
                }} data-id="element-3012"></div>
                </div>
                <div className="mt-3 flex justify-between text-xs text-gray-500 dark:text-gray-400" data-id="element-3013">
                  <span data-id="element-3014">{isArabic ? 'مبتدئ' : 'Beginner'}</span>
                  <span data-id="element-3015">{isArabic ? 'متوسط' : 'Intermediate'}</span>
                  <span data-id="element-3016">{isArabic ? 'متقدم' : 'Advanced'}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* Current Unit */}
        <div className="mb-12" data-id="element-3017">
          <div className="flex items-center justify-between mb-6" data-id="element-3018">
            <h2 className="text-2xl font-semibold text-gray-900 dark:text-white" data-id="element-3019">
              {isArabic ? 'وحدتك الحالية' : 'Your Current Unit'}
            </h2>
            <Link to="/learn/path/full" className="text-blue-600 dark:text-blue-400 flex items-center gap-1 hover:underline" data-id="element-3020">
              <span data-id="element-3021">{isArabic ? 'عرض المسار الكامل' : 'View full path'}</span>
              <ArrowRightIcon className="w-4 h-4" data-id="element-3022" />
            </Link>
          </div>
          <GettingStartedUnit data-id="element-3023" />
        </div>
        {/* Learning Resources */}
        <h2 className="text-2xl font-semibold text-gray-900 dark:text-white mb-6" data-id="element-3024">
          {isArabic ? 'موارد التعلم' : 'Learning Resources'}
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-12" data-id="element-3025">
          {/* Video Lessons */}
          <div className="bg-white dark:bg-gray-800 rounded-xl shadow-md overflow-hidden group hover:shadow-lg transition-all" data-id="element-3026">
            <div className="relative h-40" data-id="element-3027">
              <img src="https://images.unsplash.com/photo-1522202176988-66273c2fd55f?ixlib=rb-4.0.3&auto=format&fit=crop&w=1200&q=80" alt="Video lessons" className="w-full h-full object-cover transition-transform group-hover:scale-105" data-id="element-3028" />
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 to-transparent flex items-end" data-id="element-3029">
                <div className="p-4 text-white" data-id="element-3030">
                  <h3 className="text-lg font-semibold" data-id="element-3031">
                    {isArabic ? 'دروس الفيديو' : 'Video Lessons'}
                  </h3>
                </div>
              </div>
            </div>
            <div className="p-4" data-id="element-3032">
              <p className="text-gray-600 dark:text-gray-300 mb-4" data-id="element-3033">
                {isArabic ? 'تعلم من خلال دروس فيديو تفاعلية مع شرح مفصل' : 'Learn through interactive video lessons with detailed explanations'}
              </p>
              <Link to="/learn/video-lessons" className="inline-flex items-center text-blue-600 dark:text-blue-400 group-hover:underline" data-id="element-3034">
                <PlayCircleIcon className="w-5 h-5 mr-1" data-id="element-3035" />
                <span data-id="element-3036">{isArabic ? 'استكشف الدروس' : 'Explore lessons'}</span>
              </Link>
            </div>
          </div>
          {/* Practice Exercises */}
          <div className="bg-white dark:bg-gray-800 rounded-xl shadow-md overflow-hidden group hover:shadow-lg transition-all" data-id="element-3037">
            <div className="relative h-40" data-id="element-3038">
              <img src="https://images.unsplash.com/photo-1434030216411-0b793f4b4173?ixlib=rb-4.0.3&auto=format&fit=crop&w=1200&q=80" alt="Practice exercises" className="w-full h-full object-cover transition-transform group-hover:scale-105" data-id="element-3039" />
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 to-transparent flex items-end" data-id="element-3040">
                <div className="p-4 text-white" data-id="element-3041">
                  <h3 className="text-lg font-semibold" data-id="element-3042">
                    {isArabic ? 'تمارين تفاعلية' : 'Practice Exercises'}
                  </h3>
                </div>
              </div>
            </div>
            <div className="p-4" data-id="element-3043">
              <p className="text-gray-600 dark:text-gray-300 mb-4" data-id="element-3044">
                {isArabic ? 'تدرب على ما تعلمته من خلال تمارين تفاعلية متنوعة' : "Practice what you've learned through various interactive exercises"}
              </p>
              <Link to="/learn/practice" className="inline-flex items-center text-blue-600 dark:text-blue-400 group-hover:underline" data-id="element-3045">
                <PenIcon className="w-5 h-5 mr-1" data-id="element-3046" />
                <span data-id="element-3047">{isArabic ? 'ابدأ التمرين' : 'Start practicing'}</span>
              </Link>
            </div>
          </div>
          {/* Social Learning */}
          <div className="bg-white dark:bg-gray-800 rounded-xl shadow-md overflow-hidden group hover:shadow-lg transition-all" data-id="element-3048">
            <div className="relative h-40" data-id="element-3049">
              <img src="https://images.unsplash.com/photo-1543269865-cbf427effbad?ixlib=rb-4.0.3&auto=format&fit=crop&w=1200&q=80" alt="Social learning" className="w-full h-full object-cover transition-transform group-hover:scale-105" data-id="element-3050" />
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 to-transparent flex items-end" data-id="element-3051">
                <div className="p-4 text-white" data-id="element-3052">
                  <h3 className="text-lg font-semibold" data-id="element-3053">
                    {isArabic ? 'التعلم الاجتماعي' : 'Social Learning'}
                  </h3>
                </div>
              </div>
            </div>
            <div className="p-4" data-id="element-3054">
              <p className="text-gray-600 dark:text-gray-300 mb-4" data-id="element-3055">
                {isArabic ? 'تعلم وتفاعل مع متعلمين آخرين من خلال منتديات المناقشة' : 'Learn and interact with other learners through discussion forums'}
              </p>
              <Link to="/community/discussions" className="inline-flex items-center text-blue-600 dark:text-blue-400 group-hover:underline" data-id="element-3056">
                <MessageSquareIcon className="w-5 h-5 mr-1" data-id="element-3057" />
                <span data-id="element-3058">{isArabic ? 'انضم إلى المجتمع' : 'Join community'}</span>
              </Link>
            </div>
          </div>
        </div>
        {/* Educational Videos Promo */}
        <div className="bg-white dark:bg-gray-800 rounded-xl shadow-md overflow-hidden" data-id="element-3059">
          <div className="flex flex-col md:flex-row" data-id="element-3060">
            <div className="md:w-1/2 p-8" data-id="element-3061">
              <div className="flex items-center gap-3 mb-4" data-id="element-3062">
                <div className="p-2 bg-purple-100 dark:bg-purple-900/30 rounded-lg" data-id="element-3063">
                  <PlayCircleIcon className="w-5 h-5 text-purple-600 dark:text-purple-400" data-id="element-3064" />
                </div>
                <h2 className="text-xl font-semibold text-gray-900 dark:text-white" data-id="element-3065">
                  {isArabic ? 'فيديوهات تعليمية' : 'Educational Videos'}
                </h2>
              </div>
              <p className="text-gray-700 dark:text-gray-300 mb-6" data-id="element-3066">
                {isArabic ? 'اكتشف طريقة جديدة للتعلم من خلال فيديوهات قصيرة ومنشورات تعليمية مصممة خصيصًا لمساعدتك على التعلم بسرعة وبطريقة ممتعة.' : 'Discover a new way to learn through short videos and educational posts specifically designed to help you learn quickly and in an engaging way.'}
              </p>
              <Link to="/learn/educational-videos" className="inline-flex items-center gap-2 px-6 py-3 bg-purple-600 text-white rounded-xl hover:bg-purple-700 transition-colors" data-id="element-3067">
                <BookOpenIcon className="w-5 h-5" data-id="element-3068" />
                <span data-id="element-3069">
                  {isArabic ? 'استكشف الفيديوهات التعليمية' : 'Explore Educational Videos'}
                </span>
              </Link>
            </div>
            <div className="md:w-1/2 bg-gradient-to-br from-purple-50 to-blue-50 dark:from-purple-900/20 dark:to-blue-900/20 p-8 flex items-center justify-center" data-id="element-3070">
              <div className="relative w-64 h-64" data-id="element-3071">
                <div className="absolute top-0 left-0 w-56 h-56 bg-white dark:bg-gray-800 rounded-lg shadow-lg transform -rotate-6" data-id="element-3072">
                  <img src="https://images.unsplash.com/photo-1522202176988-66273c2fd55f?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80" alt="Educational content" className="w-full h-full object-cover rounded-lg" data-id="element-3073" />
                </div>
                <div className="absolute bottom-0 right-0 w-56 h-56 bg-white dark:bg-gray-800 rounded-lg shadow-lg transform rotate-6" data-id="element-3074">
                  <img src="https://images.unsplash.com/photo-1543165796-5426273eaab3?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80" alt="Educational content" className="w-full h-full object-cover rounded-lg" data-id="element-3075" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>;
}